// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"eJbeF","icon":"U1DOY"};